module.exports = __webpack_public_path__ + "img/account_balance_wallet.0a648161.svg";